<ng-container [ngSwitch]="sentWithString">
  <ng-container *ngSwitchCase="'automata'">
    <span
      matTooltip="Message sent via Automata"
      i18n-matTooltip
      matTooltipClass="text-center"
      matTooltipPosition="above"
      class="via"
      ><ng-container i18n>via</ng-container>
      <img class="via-automata" src="//cdn.tokeet.com/icons/automata_icon.png" alt=""
    /></span>
  </ng-container>
  <ng-container *ngSwitchCase="'tokeet'"></ng-container>
  <ng-container *ngSwitchCase="'sympl'"></ng-container>
  <ng-container *ngSwitchDefault>
    <span class="via" *ngIf="!!sentWithString"
      ><ng-container i18n>via</ng-container>
      <span [ngClass]="'badge-' + badgeType" class="badge text-capitalize">{{ sentWithString }}</span></span
    >
  </ng-container>
</ng-container>
